webpackJsonp([74],{

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1280);


/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _it = __webpack_require__(791);

var _it2 = _interopRequireDefault(_it);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('it', _it2.default);

/***/ })

},[1279]);


// WEBPACK FOOTER //
// app/datetime.it-71b6d51477d32e8c37e3.js